// Copyright 2018-2024 the Deno authors. All rights reserved. MIT license.
// This module is browser compatible.

import { isWindows } from "./_os.ts";
import { toFileUrl as posixToFileUrl } from "./posix/to_file_url.ts";
import { toFileUrl as windowsToFileUrl } from "./windows/to_file_url.ts";

/**
 * Converts a path string to a file URL.
 *
 * @example Usage
 * ```ts
 * import { toFileUrl } from "@std/path/to-file-url";
 * import { assertEquals } from "@std/assert";
 *
 * if (Deno.build.os === "windows") {
 *   assertEquals(toFileUrl("\\home\\foo"), new URL("file:///home/foo"));
 *   assertEquals(toFileUrl("C:\\Users\\foo"), new URL("file:///C:/Users/foo"));
 *   assertEquals(toFileUrl("\\\\127.0.0.1\\home\\foo"), new URL("file://127.0.0.1/home/foo"));
 * } else {
 *   assertEquals(toFileUrl("/home/foo"), new URL("file:///home/foo"));
 * }
 * ```
 *
 * @param path Path to convert to file URL.
 * @returns The file URL equivalent to the path.
 */
export function toFileUrl(path: string): URL {
  return isWindows ? windowsToFileUrl(path) : posixToFileUrl(path);
}

// denoCacheMetadata={"headers":{"last-modified":"Fri, 01 Nov 2024 10:38:02 GMT","etag":"\"946d83eccf4af928d77502686f29a223\"","access-control-allow-origin":"*","expires":"Sat, 08 Nov 2025 09:43:00 GMT","access-control-expose-headers":"*","cross-origin-resource-policy":"cross-origin","x-robots-tag":"noindex","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","x-jsr-cache-id":"IAD","x-goog-generation":"1730457482774979","content-type":"text/typescript","date":"Fri, 08 Nov 2024 09:43:00 GMT","x-jsr-cache-status":"hit","x-content-type-options":"nosniff","via":"1.1 google","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","age":"1621","x-goog-storage-class":"STANDARD","accept-ranges":"bytes","x-goog-stored-content-length":"1078","x-goog-hash":"crc32c=Jd4ieQ==,md5=lG2D7M9K+SjXdQJobymiIw==","content-length":"1078","x-goog-stored-content-encoding":"identity","x-guploader-uploadid":"AHmUCY1t4OtgaMRN09VhkzVuRky4_wqDSXYkjZiTYbIGwqSmxcXoX9xEZAZRJf3qxIcC7-mScHEgYMJ1-w","cache-control":"public, max-age=31536000, immutable","x-goog-metageneration":"1","server":"UploadServer"},"url":"https://jsr.io/@std/path/1.0.8/to_file_url.ts","time":1731060600}